var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"pt-15"},[_c('customize-header',{attrs:{"homeRouter":"/assistantAccount/Home","homeTitle":"公众号助手","links":_vm.links}}),_c('router-view'),_c('customize-suspendBtn'),_c('customize-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }